import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ROUTES } from '@constants/index'
import { EligibleProductStatus } from '@typesApp/Product'
import { closeApp } from '@redux/slices/workflowSlice'
import { eligibleProductStatusSelector } from '@redux/slices/claimStatusSlice'
import { usePathBuilder } from '@hooks/usePathBuilder'
import { useAppNavigate } from '@hooks/useAppNavigate'
import { useSessionInfo } from '@hooks/useSessionInfo'
import { ViewNavigationUtil } from '@utils/viewNavigationUtil'
import { LoadingSkeleton } from './LoadingSkeleton/LoadingSkeleton'

export const LoginRedirect: React.FC = () => {
  const dispatch = useDispatch()
  const navigate = useAppNavigate()
  const buildPath = usePathBuilder()
  const { isActiveDataChecked, isRestricted, isRestrictedCheckPerformed } = useSessionInfo()
  const productStatus = useSelector(eligibleProductStatusSelector)

  useEffect(() => {
    if (!isActiveDataChecked || !isRestrictedCheckPerformed) return

    if (productStatus === EligibleProductStatus.NOT_ELIGIBLE || isRestricted) {
      dispatch(closeApp())
    } else if (productStatus === EligibleProductStatus.ELIGIBLE) {
      const loginRedirectView = ViewNavigationUtil.getLoginRedirectView()
      navigate(buildPath(loginRedirectView ?? ROUTES.BASE))
    }
  }, [dispatch, navigate, buildPath, productStatus, isRestricted, isRestrictedCheckPerformed, isActiveDataChecked])

  return <LoadingSkeleton />
}
